import { useRef } from "react"
import { useTranslation } from "react-i18next"
import { Grid } from "@mui/material"

import usePermissions from "helpers/hooks/usePermissions"
import TitleWithAvatar from "widgets/common/TitleWithAvatar"
import { HeaderContainer } from "widgets/styled/containers"
import { useFullDeviceRows } from "helpers/hooks/devices/useFullDeviceRows"
import CreateDeviceButton from "./editor/CreateDeviceButton"
import DevicesTable from "./DevicesTable"

const OrgDevices = () => {
  const { t } = useTranslation()
  const {
    devicesRowsByInstallationStatus,
    installedOnLoading,
    statusesLoading,
    isLoading: devicesLoading,
    isFirstFetch,
  } = useFullDeviceRows()
  const { isBackoffice } = usePermissions()
  const sectionRef = useRef<HTMLDivElement>(null)

  return (
    <Grid item xs={12} ref={sectionRef}>
      <HeaderContainer>
        <TitleWithAvatar entity="device" title={t("generic.DEVICES")} titleVariant="h4" />
        {isBackoffice && <CreateDeviceButton />}
      </HeaderContainer>
      <DevicesTable
        devices={devicesRowsByInstallationStatus}
        statusesLoading={statusesLoading}
        installedOnLoading={installedOnLoading}
        isWaiting={devicesLoading || isFirstFetch}
        showInstallationTabs
        scrollAnchorRef={sectionRef}
      />
    </Grid>
  )
}

export default OrgDevices
